// extracted by mini-css-extract-plugin
module.exports = {"root":"root--AJh4K","complaintsWrapper":"complaintsWrapper--lI4At","complaintsItem":"complaintsItem--pCyTi","complaintsTitle":"complaintsTitle--8KNOY"};